import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div<{ $qtdColumns: string }>`
	width: 100%;
	display: grid;
	grid-template-columns: ${(props) =>
		props.$qtdColumns === '' ? '1fr 1fr ' : props.$qtdColumns};

	@media (max-width: 1000px) {
		overflow-y: hidden;
		overflow-x: auto;
	}
`;

export const itemTab = styled.div<{ $isSelected: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
	cursor: pointer;
	padding: 1rem;
	border-bottom: ${(props) =>
		props.$isSelected ? `none` : `1px solid ${color.interface.lightGray2}`};
	border-top: ${(props) =>
		props.$isSelected ? `1px solid ${color.interface.lightGray2}` : `none`};
	border-left: ${(props) =>
		props.$isSelected ? `1px solid ${color.interface.lightGray2}` : `none`};
	border-right: ${(props) =>
		props.$isSelected ? `1px solid ${color.interface.lightGray2}` : `none`};
	border-radius: 5px 5px 0px 0px;

	@media (max-width: 879px) {
		width: 200px;
		margin-bottom: 1rem;
	}
`;

export const titleTab = styled.p<{ $isSelected: boolean }>`
	font-size: 1.4rem;
	color: ${(props) =>
		props.$isSelected
			? `${color.system.success}`
			: `${color.interface.darkgray3}`};

	font-weight: ${(props) => (props.$isSelected ? `600` : `300`)};
	opacity: ${(props) => (props.$isSelected ? `1` : `0.5`)};
	text-align: center;

	@media (max-width: 1000px) {
		font-size: 1.5rem;
	}
`;
